import { HTTP } from '../../../api/resources';
import React, { useState } from "react";

export default function PaymentTypeModal({paymentLink, autopay, invoice, user = null}) {
    const [sessionUrl, setSessionUrl] = useState('');


    const handleClick = () => {

        HTTP.post(`/checkout`, {
            invoice: invoice,
        })
        .then((response) => {
            window.location.href = response.data.url;
        })
        .catch((e) => {
            Alert.show("error", "Could not open the page. Try again or refresh.");
        });
    }

  return (
    <div>
        <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
            <div className="bg-white mx-auto rounded shadow p-5 text-center">
                <div>
                    Do you want to pay for this invoice only or signup for auto payments, if you activate auto payments you will be <br/>
                    charged automatically for each invoice in this recurring invoice on their due dates
                </div>
                <div className="pt-3">
                    <button onClick={handleClick} type="button" className="btn btn-primary mr-2">
                        Use auto pay
                    </button>
                </div>
                    {/* <a href={invoice.payment_link_url} target="_blank" style={{ textDecoration: 'none', color: 'unset' }}>
                        <small>Pay this invoice</small>
                    </a> */}
            </div>
        </div>
    </div>
  )
}
